import React from "react";

import Wrapper from "./Wrapper";
import Leaf from "../Leaf";

class Tree extends React.Component {
  constructor(props) {
    super(props);

    this.state = { items: [] };

    this.onData = this.onData.bind(this);

    // Set the loader or an empty loader.
    this.loader = props.loader;
    this.rootsSelector = props.rootsSelector || (source => source);
  }

  componentDidMount() {
    this.loader().then(this.onData);
  }

  onData(items) {
    this.setState({ items });
  }

  render() {
    const props = this.props;
    const items = this.state.items;
    const root = this.rootsSelector(items);

    return (
      <Wrapper>
        {root.map((item, key) => (
          <Leaf
            {...this.props}
            key={key}
            item={item}
            items={items}
            open={props.isOpen(item)}
            selected={props.isSelected(item)}
            childItems={props.childrenSelector(item, items)}
          />
        ))}
      </Wrapper>
    );
  }
}

export default Tree;
